import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash02 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.3333 5.00001V4.33334C12.3333 3.39992 12.3333 2.93321 12.1517 2.57669C11.9919 2.26308 11.7369 2.00812 11.4233 1.84833C11.0668 1.66667 10.6001 1.66667 9.66667 1.66667H8.33333C7.39991 1.66667 6.9332 1.66667 6.57668 1.84833C6.26308 2.00812 6.00811 2.26308 5.84832 2.57669C5.66667 2.93321 5.66667 3.39992 5.66667 4.33334V5.00001M1.5 5.00001H16.5M14.8333 5.00001V14.3333C14.8333 15.7335 14.8333 16.4335 14.5608 16.9683C14.3212 17.4387 13.9387 17.8212 13.4683 18.0609C12.9335 18.3333 12.2335 18.3333 10.8333 18.3333H7.16667C5.76654 18.3333 5.06647 18.3333 4.53169 18.0609C4.06129 17.8212 3.67883 17.4387 3.43915 16.9683C3.16667 16.4335 3.16667 15.7335 3.16667 14.3333V5.00001",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTrash02;
